import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";
import { useState,useEffect } from "react";
import { branches } from "../../services/data";

const mapContainerStyle = {
  width: "100%",
  height: "800px",
  margin:"auto"
};
const mapContainerStyle_m = {
  width: "100%",
  height: "800px",
  margin:"auto"
};

const center = {
  lat: 20.5937, 
  lng: 78.9629
};

const indiaBounds = {
  north: 35.513327, 
  south: 6.462700, 
  east: 97.395358,  
  west: 68.109700, 
};

const GoogleMapsComponent = () => {
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [Markers,setMarkers]=useState([]);

  useEffect(()=>{
    setTimeout(()=>{
      setMarkers(branches);
    },[1000])
  },[]);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDmI7lJu9SNRXemfu-hWzGwZbNCdomlSvM",
  });

  if (!isLoaded) return <h1>Loading...</h1>;

  return (
    <div className="GMaps" id="googleMaps">
      <GoogleMap
      mapContainerStyle={window.innerWidth<600?mapContainerStyle_m:mapContainerStyle}
      center={center}
      zoom={window.innerWidth<600?4:6}
      // options={{
      //   restriction: {
      //     latLngBounds: indiaBounds,
      //     strictBounds: true,
      //   },
      // }}
    >
     
      {Markers.length<0?<div></div>:Markers.map((office) => (
        <Marker
          key={office.id} 
          position={{ lat: office.lat, lng: office.lng }}
          //icon={allImages.clogo}
          onMouseOver={() => setSelectedOffice(office)}
          onClick={() => setSelectedOffice(office)}
          onMouseOut={() => setTimeout(()=>setSelectedOffice(null),1500)}
        />
      ))}

      {selectedOffice && (
        <InfoWindow
          position={{ lat: selectedOffice.lat, lng: selectedOffice.lng }}
          onCloseClick={() => setSelectedOffice(null)}
          visible={!Markers===null}
        >
          <div className="addresscards">
            <div><h4>{selectedOffice.location}</h4></div>
            <div className="label"><label>Address</label>{selectedOffice.address}</div>
            {selectedOffice?.tel!==undefined?<div className="label"><label>Telephone</label>{selectedOffice.tel.toString()}</div>:<span/>}
            {selectedOffice?.fax!==undefined?<div className="label"><label>Fax</label>{selectedOffice.fax}</div>:<span/>}
            {selectedOffice?.email!==undefined?<div className="label"><label>Email</label>{selectedOffice.email.toString()}</div>:<span/>}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
    </div>
  );
};

export default GoogleMapsComponent;
